<template>
  <div style="position: relative">
    <div id="progress" :style="style">
      <div :style="leftStyle">
        <span :style="fontstyle">{{ number }}</span>
      </div>
      <div
        :style="{ textAlign: 'center', verticalAlign: 'middle' }"
        v-if="total - number"
      >
        <span :style="fontstyle">{{ total - number }}</span>
      </div>
    </div>
    <div style="position: absolute; right: -30px;width:20px;">
      <span :style="{ color: totalFontColor, verticalAlign: 'middle' }">{{
        total
      }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "MyProgress",
  props: [
    "number",
    "total",
    "border",
    "color",
    "height",
    "fontcolor",
    "totalFontColor",
    "width",
  ],
  mounted() {
    const width =
      (this.number / this.total) *
      document.getElementById("progress").offsetWidth;
    // console.log(width);
    this.leftStyle.width = width + "px";
    // console.log(this.leftStyle);
    this.$forceUpdate();
  },
  data() {
    return {
      style: {
        border: this.border,
        height: this.height + "px",
        borderRadius: "4px",
        width: "100%",
        float: "left",
        lineHeight: this.height + "px",
      },
      leftStyle: {
        backgroundColor: this.color,
        borderRight: this.border,
        textAlign: "center",
        verticalAlign: "center",
        float: "left",
        borderRadius: "4px",
        marginTop: "0px",
        marginBottom: "0px",
        height: this.height - 2 + "px",
      },
      fontstyle: {
        color: this.fontcolor,
      },
    };
  },
};
</script>

<style scoped>
.a {
}
</style>